import * as React from 'react';
import { ReportFieldDefinition } from "../../../../models";
import { MultipleCheckboxes } from '../../fields';

interface MultiOptionsFieldProps {
    id: string,
    value?: string,
    fieldDefinition: ReportFieldDefinition,
    style?: React.CSSProperties,
    readOnly?: boolean,
    invalid?: boolean,
    onChange?: (value: string) => void,
}

export const MultiOptionsField: React.FC<MultiOptionsFieldProps> = ({
    id,
    value,
    style,
    fieldDefinition,
    readOnly,
    onChange,
}) => {
    return <MultipleCheckboxes 
        id={id} 
        style={style}
        values={value?.split('|')} 
        highlightChecked
        onChange={values => onChange && onChange(values.join('|'))} 
        disabled={readOnly} 
        options={fieldDefinition.aditionalFields?.options?.split('|')}
    />
}